import { createSelector } from '@ngrx/store';
import { createSlice, PayloadAction } from 'ngrx-slice';

import { StatementResponse } from '@app/api/marketplace/models';

export interface State {
  statementLoadError: boolean;
  statementLoading: boolean;
  statement: StatementResponse | undefined;
}

export const initialState: State = {
  statementLoading: false,
  statementLoadError: false,
  statement: undefined,
};

export const {
  actions: StatementActions,
  selectors,
  ...StatementFeature
} = createSlice({
  name: 'statement',
  initialState,
  reducers: {
    loadStatement: {
      trigger: (state) => {
        state.statementLoading = true;
      },
      success: (state, action: PayloadAction<StatementResponse>) => {
        state.statement = action;
        state.statementLoading = false;
        state.statementLoadError = false;
      },
      failure: (state) => {
        state.statementLoading = false;
        state.statementLoadError = true;
      },
    },
    reset: (_) => initialState,
  },
});

export const StatementSelectors = {
  ...selectors,
  selectStatementId: createSelector(
    selectors.selectStatement,
    (statement) => statement?.actualStatementId
  ),
  selectStatementContent: createSelector(
    selectors.selectStatement,
    (statement) => statement?.statement
  ),
};
